import api from './apiRequestConfig';

export const getRecipientMedications = async ({ userId, recipientId }) => {
  const { data: response } = await api.get(
    process.env.REACT_APP_EXPRESS_URL + `/api/canCare/caregiver/${userId}/userMedications/${recipientId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const deleteMedications = async ({ userId, recipientId, medIds }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/deleteRecipientMedications/${recipientId}`,
    {
      selected: JSON.stringify(medIds),
    },
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const getCaregivers = async ({ userId, filter }) => {
  const { data: response } = await api.get(
    process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${userId}/getCaregivers?filter=${filter}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const getRecipientCaregivers = async ({ userId, recipientId }) => {
  const { data: response } = await api.get(
    process.env.REACT_APP_EXPRESS_URL + `/api/canCare/caregiver/${userId}/userCaregivers/${recipientId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const deleteCaregivers = async ({ userId, caregivers }) => {
  const { data: response } = await api.post(
    process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${userId}/deleteCaregivers`,
    { caregivers },
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const getCareRecipients = async ({ userId, filter = '' }) => {
  const { data: response } = await api.get(
    process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${userId}/getCareRecipients?filter=${filter}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const changeRelationStatus = async ({ userId, relationId, status }) => {
  const { data: response } = await api.post(
    process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${userId}/changeRelationStatus`,
    { relationId, status },
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};
export const getTodayMedications = async ({ userId }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/todayMedications`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};
export const getRecipientTodayMedications = async ({ userId, selectedRecipient }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/userTodayMedications/${selectedRecipient}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const updateRecipientTodayMedications = async ({ userId, selectedRecipient, eventId, status }) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/userTodayMedications/${selectedRecipient}`,
    {
      eventId,
      status,
      reminder: null,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const updateTodayMedications = async ({ userId, eventId, status }) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/todayMedications`,
    {
      eventId,
      status,
      reminder: null,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const getDailyEvents = async ({ userId, fromDashboard = null }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/getDailyEvents?fromDashboard=${fromDashboard}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const getUserDevices = async ({ userId, selectedRecipient }) => {
  const { data: response } = await api.get(
    process.env.REACT_APP_EXPRESS_URL + `/api/canCare/caregiver/${userId}/recipientDevices/${selectedRecipient}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const getDevices = async ({ userId }) => {
  const { data: response } = await api.get(
    process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${userId}/getMyDevices`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const findMyDevice = async ({ userId, deviceId }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/users/${userId}/findMyCane/${deviceId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};
export const getWalkActivity = async ({ userId, deviceId, filter = 'daily' }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/devices/${deviceId}/todayWalkingActivity/${userId}/${filter}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};
export const getLocation = async ({ userId }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/latestLocation`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const getUserLocation = async ({ userId, recipientId }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/latestLocation/${recipientId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const loginApi = async ({ email, password, fcmToken }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/users/login`,
    { email, password, fcmToken },
    {
      headers: {
        'Content-Type': 'application/json',
        Platform: 'web',
      },
    },
  );
  return response;
};

export const forgotPassword = async ({ email }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/users/reset`,
    { email },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  return response;
};

export const resetPassword = async ({ password, accessToken }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/users/reset-password?access_token=${accessToken}`,
    { newPassword: password },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  return response;
};

export const signupApi = async ({ email, password }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/signupFromPortal`,
    { email, password, token: null },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  return response;
};

export const resendOtpApi = async ({ email }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/resendOtp?portal=true`,
    { email },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  return response;
};

export const verifyOtpApi = async ({ email, otp }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/verifyOtp`,
    { email, otp },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  return response;
};
export const updateUserType = async ({ userId = sessionStorage.getItem('userId'), userType }) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/userType`,
    { userType },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: sessionStorage.getItem('token'),
      },
    },
  );
  return response;
};

export const updateUserInfo = async ({ userId = sessionStorage.getItem('userId'), body }) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/userInfo`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
      },
    },
  );
  return response;
};

export const getUserInfo = async ({ userId = sessionStorage.getItem('userId') }) => {
  const { data: response } = await api.get(`${process.env.REACT_APP_EXPRESS_URL}/api/users/${userId}/userInfo`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: sessionStorage.getItem('token'),
    },
  });
  return response;
};

export const inviteCareRecipient = async ({ userId = sessionStorage.getItem('userId'), phoneNo, email }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/inviteRecipient`,
    {
      email,
      phoneNo,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: sessionStorage.getItem('token'),
      },
    },
  );
  return response;
};

export const checkDevicePin = async ({ pin }) => {
  const { data: response } = await api.get(`${process.env.REACT_APP_EXPRESS_URL}/api/devices/check-pin/${pin}`, {
    headers: {
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
    },
  });

  return response;
};

export const pairDeviceApi = async ({ userId = sessionStorage.getItem('userId'), pin }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/pairDevice`,
    { devicePin: pin },
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
      },
    },
  );

  return response;
};

export const getTokenData = async ({ token }) => {
  const { data: response } = await api.get(
    process.env.REACT_APP_EXPRESS_URL + `/api/canCare/getTokenData?token=${token}`,
  );
  return response;
};
export const signupByInvite = async ({ body }) => {
  const { data: response } = await api.post(`${process.env.REACT_APP_EXPRESS_URL}/api/canCare/signupByInvite`, body, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response;
};

export const getUserDailyEvents = async ({ userId, recipientId, fromDashboard = null }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/userDailyEvents/${recipientId}?fromDashboard=${fromDashboard}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const changePasswordApi = async ({ oldPassword, newPassword }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/users/change-password`,
    {
      oldPassword,
      newPassword,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const updateDeviceInfoApi = async ({ userId, deviceId, body }) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/deviceInfo/${deviceId}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const updateDeviceConfigApi = async ({ userId, deviceId, body }) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/deviceConfig/${deviceId}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const updateDeviceCaregiversApi = async ({ userId, body }) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/deviceCaregivers`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const updateUserEmergencyApi = async ({ userId, caregiverId }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/userEmergency/${caregiverId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const updateRecipientDeviceInfoApi = async ({ userId, recipientId, deviceId, body }) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/deviceInfo/${recipientId}/device/${deviceId}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const updateRecipientDeviceConfigApi = async ({ userId, recipientId, deviceId, body }) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/deviceConfig/${recipientId}/device/${deviceId}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const pairRecipientDeviceApi = async ({ userId, recipientId, pin }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/pairDevice/${recipientId}`,
    { devicePin: pin },
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
      },
    },
  );

  return response;
};

export const addDiagnosisApi = async ({ userId, recipientId, body }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/diagnosis/${recipientId}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
      },
    },
  );

  return response;
};

export const getDiagnosisApi = async ({ userId, recipientId }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/diagnosis/${recipientId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
      },
    },
  );

  return response;
};

export const deleteDiagnosisApi = async ({ userId, recipientId, diagnosisId }) => {
  const { data: response } = await api.delete(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/diagnosis/${recipientId}/${diagnosisId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
      },
    },
  );

  return response;
};

export const updateDiagnosisApi = async ({ userId, recipientId, diagnosisId, body }) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/diagnosis/${recipientId}/${diagnosisId}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
      },
    },
  );

  return response;
};

export const getUserDocuments = async ({ userId, recipientId }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/documents/${recipientId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );

  return response;
};

export const deleteUserDocuments = async ({ userId, recipientId, documentId }) => {
  const { data: response } = await api.delete(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/documents/${recipientId}/${documentId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );

  return response;
};

export const downloadUserDocuments = async ({ userId, recipientId, documentId }) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/documents/${recipientId}/${documentId}`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );

  return response;
};

export const addDoctorApi = async ({ userId, recipientId, body }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/doctor/${recipientId}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
      },
    },
  );

  return response;
};

export const getDoctorApi = async ({ userId, recipientId }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/doctor/${recipientId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
      },
    },
  );

  return response;
};

export const updateDoctorApi = async ({ userId, recipientId, body, doctorId }) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/doctor/${recipientId}/${doctorId}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
      },
    },
  );

  return response;
};

export const deleteDoctorApi = async ({ userId, recipientId, doctorId }) => {
  const { data: response } = await api.delete(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/doctor/${recipientId}/${doctorId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
      },
    },
  );

  return response;
};

export const addAllergiesApi = async ({ userId, recipientId, body }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/allergies/${recipientId}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
      },
    },
  );

  return response;
};

export const updateAllergiesApi = async ({ userId, recipientId, allergyId, body }) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/allergies/${recipientId}/${allergyId}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
      },
    },
  );

  return response;
};

export const deleteAllergiesApi = async ({ userId, recipientId, allergyId }) => {
  const { data: response } = await api.delete(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/allergies/${recipientId}/${allergyId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
      },
    },
  );

  return response;
};

export const getAllergiesApi = async ({ userId, recipientId }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/allergies/${recipientId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth') || sessionStorage.getItem('token'),
      },
    },
  );

  return response;
};

export const getUserInstructionsApi = async ({ userId, recipientId }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/instructions/${recipientId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );

  return response;
};

export const addUserInstructionsApi = async ({ userId, recipientId, body }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/instructions/${recipientId}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );

  return response;
};

export const updateUserInstructionsApi = async ({ userId, recipientId, instructionId, body }) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/instructions/${recipientId}/${instructionId}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );

  return response;
};

export const deleteUserInstructionsApi = async ({ userId, recipientId, instructionId }) => {
  const { data: response } = await api.delete(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/instructions/${recipientId}/${instructionId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );

  return response;
};

export const getUserInsuranceApi = async ({ userId, recipientId }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/insurance/${recipientId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );

  return response;
};

export const addUserInsuranceApi = async ({ userId, recipientId, body }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/insurance/${recipientId}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );

  return response;
};

export const updateUserInsuranceApi = async ({ userId, recipientId, insuranceId, body }) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/insurance/${recipientId}/${insuranceId}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );

  return response;
};

export const deleteUserInsuranceApi = async ({ userId, recipientId, insuranceId }) => {
  const { data: response } = await api.delete(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/insurance/${recipientId}/${insuranceId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );

  return response;
};

export const getActivityApi = async ({ userId }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/recentActivity`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );

  return response;
};

export const getRecipientActivityApi = async ({ userId, recipientId }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/recentActivity/${recipientId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );

  return response;
};

export const chatWithCompanion = async ({ userId, message }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/users/${userId}/companion-chat`,
    { message },
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );

  return response;
};
export const getVitalsGraphData = async ({ userId, type, period, showComparison }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/vitalsGraph/${type}?filter=${period}&isCompare=${showComparison}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};
export const getRecpientVitalsGraphData = async ({ userId, recipientId, type, period, showComparison }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/recipientVitalsGraph/${recipientId}/${type}?filter=${period}&isCompare=${showComparison}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};
export const postGraphData = async ({ userId, healthData }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/healthDataSync`,
    healthData,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};
export const getActivitiesGraphData = async ({ userId, type, period, showComparison, deviceId }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/activitiesGraph/${type}?filter=${period}&isCompare=${showComparison}&deviceId=${deviceId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};
export const getRecipientActivitiesGraphData = async ({
  userId,
  recipientId,
  type,
  period,
  showComparison,
  deviceId,
}) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/recipientActivitiesGraph/${recipientId}/${type}?filter=${period}&isCompare=${showComparison}&deviceId=${deviceId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};
export const getFallDetectionGraphData = async ({ userId, period, showComparison }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/fallDetectionGraph?filter=${period}&isCompare=${showComparison}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const getRecipientFallDetectionGraphData = async ({ userId, recipientId, period, showComparison }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/recipientFallDetectionGraph/${recipientId}?filter=${period}&isCompare=${showComparison}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const getGaitSpeedGraphData = async ({ userId, type, period, showComparison }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/gaitSpeedGraph?filter=${period}&isCompare=${showComparison}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const getRecipientGaitSpeedGraphData = async ({ userId, recipientId, type, period, showComparison }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/recipientGaitSpeedGraph/${recipientId}?filter=${period}&isCompare=${showComparison}`,
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};
export const getUserNotifications = async (userId) => {
  const { data: response } = await api.get(`${process.env.REACT_APP_EXPRESS_URL}/api/users/${userId}/notifications`, {
    headers: {
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('auth'),
    },
  });
  return response;
};
export const readUserNotifications = async (userId, notificationId) => {
  const { data: response } = await api.put(
    `${process.env.REACT_APP_EXPRESS_URL}/api/users/${userId}/read-notifications`,
    {
      notificationId: notificationId || '',
    },
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
      },
    },
  );
  return response;
};

export const postFallRecord = async ({ userId, healthData }) => {
  const { data: response } = await api.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/fallRecord`,
    healthData,
  );
  return response;
};

export const getGlucoseGraphData = async ({ userId, period, showComparison }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/glucoseGraph?filter=${period}&isCompare=${showComparison}`,
  );
  return response;
};

export const getRecipientGlucoseGraphData = async ({ userId, recipientId, period, showComparison }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/canCare/caregiver/${userId}/recipientGlucoseGraph/${recipientId}?filter=${period}&isCompare=${showComparison}`,
  );
  return response;
};

export const getDexcomAuthUrl = async ({ userId }) => {
  const { data: response } = await api.get(`${process.env.REACT_APP_EXPRESS_URL}/api/dexcom/user/${userId}/authUrl`);
  return response;
};

export const freeStyleConnect = async ({ userId, email, password }) => {
  const { data: response } = await api.post(`${process.env.REACT_APP_EXPRESS_URL}/api/freeStyle/user/${userId}/auth`, {
    email,
    password,
  });
  return response;
};
export const deviceIntegrationStatus = async ({ userId }) => {
  const { data: response } = await api.get(
    `${process.env.REACT_APP_EXPRESS_URL}/api/users/${userId}/integrationStatus`,
  );
  return response;
};
